import { Component } from '@angular/core';

@Component({
  selector: 'cpd-conversation-skeleton',
  templateUrl: './conversation-skeleton.component.html',
  styleUrls: ['./conversation-skeleton.component.scss']
})
export class ConversationSkeletonComponent {}
